import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { RequestRmaButtonsStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaButtons";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import GuestRmaButtons from "@SupplyLand/Widgets/RequestRma/GuestRmaButtons";
import React, { FC } from "react";
import { css } from "styled-components";

export interface GuestRmaProductListButtonsStyles {
    gridContainer?: GridContainerProps;
    buttonsGridItem?: GridItemProps;
    requestRmaButtons?: RequestRmaButtonsStyles;
}

export const productListButtonsStyles: GuestRmaProductListButtonsStyles = {
    buttonsGridItem: {
        css: css`
            justify-content: flex-end;
        `,
        width: [0, 0, 0, 12, 12],
    },
};

const styles = productListButtonsStyles;

const GuestRmaProductListButtons: FC = () => {
    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.buttonsGridItem}>
                <GuestRmaButtons extendedStyles={styles.requestRmaButtons} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: GuestRmaProductListButtons,
    definition: {
        displayName: "Product List Buttons",
        allowedContexts: ["OrderStatusPage"],
        fieldDefinitions: [],
        group: "Return Request (RMA)",
    },
};

export default widgetModule;
